import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';
import { CheckOne, CheckSquared } from '@/app/components/icons/CheckOne';
import { UnCheck, UnCheckSquared } from '@/app/components/icons/UnCheck';
import { cn } from '@/app/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    variant?: 'square' | 'circle';
  }
>(({ className, variant = 'square', ...props }, ref) => (
  <CheckboxPrimitive.Root ref={ref} className={cn('group peer shrink-0', className)} {...props}>
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      {variant === 'square' ? <CheckSquared /> : <CheckOne />}
    </CheckboxPrimitive.Indicator>
    {variant === 'square' ? (
      <UnCheckSquared className="text-current group-data-[state=checked]:hidden" />
    ) : (
      <UnCheck className="text-current group-data-[state=checked]:hidden" />
    )}
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
